
import { TitleCasePipe } from "common";
import { ADPResourceService as ResourceService } from "digital-core";

export class SalesApplication {
    public ApplicationId: string;
    public ProposedInsuredName: string;
    public ProposedInsuredDoB: string;
    public ProposedInsuredState: string;
    public AgentId: string;
    public SavedDate: string;
    public ExpirationDate: string;
    public Data: string;
    public SavedDateMilisec: string;
    public ProgressBarPrct: number;
    public Status: string;
    public IMEINumber: number;
    public PolicyNumber: string;
    public CellNumber: string;
    public ProgressBarData: string;
    public SubmittedDate: string;
    public StoreBranchNumber: string
    public CancelAllowed: boolean;
    public CreatedDate: string;
    public StoreBranchName: string;
    public AllowDelete: boolean;
    public AllowCancel: boolean;
    public UserRole: string;
    public FilterType: string;
    public SelectedInsuranceType:string;


    private titleCasePipe?: TitleCasePipe = new TitleCasePipe();

    constructor(sa: SalesApplication, dateFormat: string, dateTimeFormat: string, public resourceService: ResourceService) {
        let info = JSON.parse(sa.Data)
        this.ApplicationId = sa.ApplicationId;
        this.ProposedInsuredName = this.titleCasePipe.transform(sa.ProposedInsuredName);
        this.ProposedInsuredDoB = this.resourceService.getFormattedDate(sa.ProposedInsuredDoB, dateFormat);
        this.ProposedInsuredState = sa.ProposedInsuredState;
        this.AgentId = sa.AgentId;
        this.SavedDate = this.resourceService.getFormattedDate(sa.SavedDate, dateTimeFormat);
        this.ExpirationDate = this.resourceService.getFormattedDate(sa.ExpirationDate, dateFormat);
        this.Data = sa.Data;
        this.ProgressBarPrct = info.ProgressBarData ? (info.ProgressBarData.stepsCompleted.length / info.ProgressBarData.totalSteps) * 100 : 0;
        this.SavedDateMilisec = this.resourceService.getFormattedDate(sa.SavedDateMilisec, dateFormat);
        this.Status = sa.Status !== undefined ? sa.Status : SaleApplicationStatus.Active;
        this.IMEINumber = sa.IMEINumber;
        this.PolicyNumber = sa.PolicyNumber;
        this.CellNumber = sa.CellNumber;
        this.ProgressBarData = sa.ProgressBarData;
        this.SubmittedDate = sa.SubmittedDate;
        this.StoreBranchNumber = sa.StoreBranchNumber;
        this.StoreBranchName = sa.StoreBranchName;
        this.SelectedInsuranceType = info.SalesInsuranceType;
    }
}


export enum SaleApplicationStatus {
    Active = 'A',
    Cancelled = 'C',
    Delete = 'D',
    Submitted = 'S'
}
